
import { defineComponent, computed, watch, ref } from 'vue'
import { useAgreementModule } from '@/modules/agreements'
import { useFormModule } from '@/modules/_shared/forms'

export default defineComponent({
    name: 'sso-join-rules-form-field-agreement',
    emits: ['update:modelValue'],
    props: {
        modelValue: {
            type: String
        },
        organizationId: {
            type: String,
            required: true
        }
    },
    async setup (props, { emit }) {
        const { validations: { requiredRule } } = useFormModule()
        const { agreementsSimplified, getAgreementsSimplified } = useAgreementModule()

        const localModel = computed({
            get: () => props.modelValue,
            set: value => emit('update:modelValue', value)
        })

        const organizationIdModel = ref(props.organizationId)

        watch(() => props.organizationId, (newValue) => {
            organizationIdModel.value = newValue
            localModel.value = ''
        })

        await getAgreementsSimplified()

        const organizationAgreements = computed(() => {
            return agreementsSimplified.value.filter(agreement => agreement.organizationId === organizationIdModel.value)
        })

        const agreementsOptions = computed(() => organizationAgreements.value.map((agreement) => {
            return {
                label: agreement.name,
                value: agreement.agreementId
            }
        })
        )

        const filteredOptions = ref(agreementsOptions.value)
        const filterFn = (val: string, update: (arg: () => void) => void) => {
            update(() => {
                const needle = val.toLowerCase()
                filteredOptions.value = agreementsOptions.value.filter(v => v.label.toLowerCase().indexOf(needle) > -1)
            })
        }

        const disable = computed(() => organizationIdModel.value === '')

        return {
            filteredOptions,
            filterFn,
            organizationIdModel,
            localModel,
            requiredRule,
            disable
        }
    }
})
